import { Reveal } from "@/components/Reveal";
import MaskedReveal from "@/components/MaskedReveal";
import { WHY_CHAPTERS, WHY_POINTS } from "@/data/academy";

export default function WhySeed() {
  return (
    <section className="bg-rainforest text-cream py-28 md:py-44" data-testid="why-seed">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-20 md:mb-28">
          <p className="overline text-ochre mb-7">Why seed matters</p>
          <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl font-light leading-[1.02]">
            <MaskedReveal animate={false} lines={["Recovery begins", "with seed."]} />
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-y-16">
          {WHY_CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05} className="md:col-span-10 md:col-start-2">
              <div className="grid grid-cols-1 md:grid-cols-[120px_1fr] gap-6 md:gap-16 items-start border-t border-cream/15 pt-8">
                <span className="font-serif text-6xl md:text-7xl text-ochre/80 leading-none">{c.n}</span>
                <div>
                  <h3 className="font-serif text-3xl md:text-4xl font-normal mb-4">{c.title}</h3>
                  <p className="text-cream/70 text-lg font-light leading-relaxed max-w-2xl">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-20 md:col-span-10 md:col-start-2">
          <div className="flex flex-wrap gap-x-8 gap-y-3 md:pl-[136px]">
            {WHY_POINTS.map((p) => (
              <span key={p} className="text-cream/60 text-sm border-b border-cream/20 pb-2">{p}</span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
